export const environment = {
  version: 'v2.28.3',
  production: false,
  title: 'IOT BAT',
  apiUrl: 'https://bat.api.groupe-seb.com',
  apiKey: 'puVdQHQNS3rjx2e8RDWMhkTmyGkXLCdC',
  backendUrl: 'https://bat.iot.api.groupe-seb.com/api/v1',
  metaVersionsTable: 'Meta-version',
  metaVersionsIndex: 'activated-thingType-index',
  firmwaresTable: 'Firmwares',
  firmwaresIndex: 'activated-thingType-index',
  iotDevicesTable: 'IOTDevices',
  iotDevicesIndex: 'macAddress-index',
  iotDevicesStatsTable: 'IOTDevicesStats',
  firmwareBrandAreaTable: 'FirmwareBrandArea',
  metaversionJobsTable: 'Meta-version-job',
  metaversionJobsIndex: 'metaversionId-index',
  metaversionJobsGroupIdIndex: 'groupId-jobId-index',
  groupOfThingsTable: 'GroupOfThings',
  groupOfThingsthingTypeIndex: 'thingType-groupId-index',
  firmwaresBucket: 'iot-security-com-groupeseb-firmwares',
  temporaryFirmwaresBucket: 'iot-uat-com-groupeseb-temporary-firmwares',
  userLoginHistoryTable: 'ConsoleUserLoginHistory',
  userHistoryTTL: 4320, // hours
  cognitoIdpName: 'adfs',
  cognitoUserPoolId: 'eu-west-1_ESKdNiqVD',
  cognitoClientId: '6q4pda8aotdvhbuoshhg9lge3v',
  cognitoIdentityPoolId: 'eu-west-1:de8cce8a-a49e-40e5-86d5-39819b988d61',
  cognitoDomain: 'uat-iot-api-groupe-seb.auth.eu-west-1.amazoncognito.com',
  cognitoSignInUrl: 'https://iot.console.uat.groupe-seb.com/loading',
  cognitoSignOutUrl: 'https://iot.console.uat.groupe-seb.com',
  webDomainNameV2: 'iot.console.uat.groupe-seb.com',
  cognitoReponseType: 'code',
  awsRegion: 'eu-west-1',
  iotEndpoint: 'd08645953m2crm0gi18mh-ats.iot.eu-west-1.amazonaws.com',
  iotPolicyName: 'AdminConsole-IotPolicy-ONXQC54XWT2S',
  unsignedFolder: 'uat/unsigned',
  signedFolder: 'uat/signed',
  domainCertificateARN: 'arn:aws:acm:us-east-1:178444588076:certificate/ced17386-ed80-48a2-bf6a-76eb4e89316f',
  searchMaxResults: 20,
  thingArnPrefix: 'arn:aws:iot:eu-west-1:178444588076:thing/',
  crossOriginLambda: 'CallCrossOrigin',
  teamsWebhookUrl: 'https://groupeseb.webhook.office.com/webhookb2/79f88e84-15e1-4ea1-8666-5ebef28ac4ba@bcccbda4-a4dc-4cf5-b7cb-7a3869ac0856/IncomingWebhook/65e534c4cd7f4788a4350474d4f3fa5d/50fd6373-8fbd-4619-9d4d-454b55b3a12a',
  teamsMessageColor: 'FFFF00',
  envTag: 'integration',
  s3ProxyReadLambda: 'S3ProxyRead',
  s3ProxyWriteLambda: 'S3ProxyWrite',
};
